import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSeat(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.049 4.54a1.25 1.25 0 0 0-2.415.647l2.588 9.659q.046.168.129.308l.012.021.01.022c.207.41.63.69 1.119.69h8a1.25 1.25 0 0 0 0-2.5h-6.113a1.25 1.25 0 0 1-1.207-.926zm-1.92-2.333A2.75 2.75 0 0 1 9.499 4.15l2.073 7.737h5.921a2.75 2.75 0 1 1 0 5.5h-8a2.75 2.75 0 0 1-2.449-1.498 2.8 2.8 0 0 1-.27-.656l-2.588-9.66A2.75 2.75 0 0 1 6.13 2.208M6.591 21.138a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.174 15.91a.75.75 0 0 1 .546.91l-1 4a.75.75 0 0 1-1.455-.364l1-4a.75.75 0 0 1 .909-.546M15.31 15.91a.75.75 0 0 1 .91.546l1 4a.75.75 0 1 1-1.455.364l-1-4a.75.75 0 0 1 .545-.91"
  })));
}
var IcSeat = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSeat));

export { IcSeat as I };
